import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const createExplanationRevisionHandler = restHandlerFactory(
  '/trials/{trial_uid}/explanations/{explanation_uid}/revisions',
  'post',
  () => HttpResponse.json(undefined, { status: 204 }),
)
